<template>
  <div class="mr-2 ml-1">
    <v-card>
      <v-card-title class=" titre mt-1 font-weight-bold white--text"> Mes Ordres actifs</v-card-title>
        <v-card-text>
            <v-data-table :headers="headers" hide-actions :items="orders" item-key="id+nm" class="elevation-0" style="overflow: auto; height:40vh;">
              <template v-slot:items="props">
                <tr :class=" props.item.bidTotal? 'green--text achat':' vente' ">
                  <td class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("en-US", {maximumFractionDigits:0}).format(props.item.bidPrice || props.item.askPrice ) }}</td>
                  <td class="text-xs-left font-weight-bold">{{ new Intl.NumberFormat("en-US",{maximumFractionDigits:6}).format(props.item.bidAmount || props.item.askAmount) }}</td>
                  <td>{{props.item.bidTotal? 'achat' : 'vente'}} </td>
                  <td class="text-xs-left">
                    <div class="remove-item title remove-item">
                      <v-btn flat>
                        <i
                          @click="submit(props.item)"
                          style="color:red"
                        >annuler</i>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapState } from "vuex";
import db from '../db'
import firebase from '../fb'
import axios from 'axios'

const user = firebase.auth().currentUser
export default {
  props: {
    asset: {
      type: String,
    },
    currency:{
      type:String
    },
    second:{
      type:String
    }
  },
  data() {
    return {
      api : process.env.VUE_APP_API,
      headers: [
        { text: "Prix", align: "left", sortable: false },
        { text: "Quantité", sortable: false },
        { text: "Type", sortable: false },
      ]
    };
  },
  computed: {
     orders(){
        let orders = []
        orders.push(...this.myBid, ...this.myAsk)
        let sorted_orders =  orders.sort((a, b) => b.created_at.seconds - a.created_at.seconds);
        return sorted_orders
      },
    ...mapState({
     
      myBid(state, getters){
        return getters["order/my"+this.currency+this.second+"Bids" ]
      },
      myAsk(state, getters){
        return getters["order/my"+this.currency+this.second+"Asks" ]
      }
    })
  },

  mounted () {
   
    

    
  },
  methods: {

    submit(item){
      console.log(item);
      item.bidTotal ? this.removeOrderBid(item.id, item.bidTotal) : this.removeOrderAsk(item.id, item.askAmount)
    },

     removeOrderBid(id, bidTotal) {
      let api = `${this.main_api}/app`
      console.log(api);
          console.log(api);
        swal({
      title: "Annuler?",
      // text: "Vous voulez vraiment annuler votre ordre?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
          let data ={  
                      id: id,
                      asset:this.asset,
                      currency: this.currency,
                      second: this.second,
                      amount: bidTotal,
                      user_id: user.uid

                    }
    console.log(data);
    if (location.hostname === "localhost") {
      //api = 'http://localhost:5000/hiropay-test-db886/us-central1/app'
    }

    console.log(api);
     axios
         .get(`${api}/remove_bid`, {
                    params: data
                    }).then((res)=>{
                      console.log(res);
                      if (res.data == 'error') {
                        swal("erreur", "", "error", {
                            button: "ok!"
                          })
                      }
                    }).catch((err)=>{
                      console.log(err);

                    })   

  } else {
    swal("Sage décision!!");
  }
});

    },
    removeOrderAsk(id, askAmount) {
          let api = `${this.main_api}/app`
          swal({
      title: "Annuler?",
      text: "Vous voulez vraiment annuler votre ordre?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
          let data ={  
                      id: id,
                      asset:this.asset,
                      currency: this.currency,
                      second: this.second,
                      amount: askAmount,
                      user_id: user.uid

                    }
    console.log(api);
     if (location.hostname === "localhost") {
      //api = 'http://localhost:5000/hiropay-test-db886/us-central1/app'
    }
      axios
         .get(`${api}/remove_ask`, {
                    params: data
                    }).then((res)=>{
                      console.log(res);
                      if (res.data == 'error') {
                        swal("erreur", "", "error", {
                            button: "ok!"
                          })
                      }
                    }).catch((err)=>{
                      console.log(err);
                    }) 
  } else {
    swal("Sage décision!!");
  }
});
    }
  }
};
</script>
<style scoped>
.vente{
  color: darkred;
}
.remove-item {
  cursor: pointer;
}
div.titre{
  background-color: #003449;
}

  table.v-table thead tr th {
  font-size: 10px;
}
table.v-table tbody tr td {
  font-size: 12px;
}

</style>

<style scoped>

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #00897B; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
</style>
